/**
 * تایمر جلسهٔ تمرکز.
 * ثانیه‌ها را از ساعت دیوار حساب می‌کنیم، نه از شمارندهٔ setInterval — چون داخل
 * مینی‌اپ تلگرام صفحه ممکن است بخوابد یا تب معلق شود و شمارنده عقب بماند.
 * همین شکل داده، بعداً بدون تغییر روی سرور هم می‌نشیند.
 */
export function elapsedMs(s, now = Date.now()) {
    const end = s.completedAt ?? s.abandonedAt ?? now;
    const pausedNow = s.pausedAt ? end - s.pausedAt : 0;
    return Math.max(0, end - s.startedAt - s.pausedMs - pausedNow);
}
export function remainingSec(s, now = Date.now()) {
    return Math.max(0, s.durationSec - Math.floor(elapsedMs(s, now) / 1000));
}
export function progress(s, now = Date.now()) {
    return Math.min(1, elapsedMs(s, now) / (s.durationSec * 1000));
}
export function isRunning(s, now = Date.now()) {
    return !!s && !s.completedAt && !s.abandonedAt && !s.pausedAt && remainingSec(s, now) > 0;
}
export function isPaused(s) {
    return !!s && !!s.pausedAt && !s.completedAt && !s.abandonedAt;
}
export function isFinished(s, now = Date.now()) {
    return !!s && (!!s.completedAt || (!s.abandonedAt && remainingSec(s, now) === 0));
}
export function pause(s, now = Date.now()) {
    if (s.pausedAt || s.completedAt || s.abandonedAt)
        return s;
    return { ...s, pausedAt: now };
}
export function resume(s, now = Date.now()) {
    if (!s.pausedAt)
        return s;
    return { ...s, pausedMs: s.pausedMs + (now - s.pausedAt), pausedAt: undefined };
}
export function complete(s, now = Date.now()) {
    return { ...s, completedAt: now, pausedAt: undefined };
}
export function abandon(s, now = Date.now()) {
    return { ...s, abandonedAt: now, pausedAt: undefined };
}
/** دقیقهٔ واقعی مطالعه در یک جلسه — فقط جلسه‌های تمام‌شده حساب می‌شوند */
export function studiedMinutes(s) {
    if (!s.completedAt)
        return 0;
    return Math.round(elapsedMs(s) / 60000);
}
export function formatClock(totalSec) {
    const m = Math.floor(totalSec / 60);
    const sec = totalSec % 60;
    return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
}
//# sourceMappingURL=focus.js.map